import { Button, Modal } from 'antd';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ReactComponent as RoundTickIcon} from '../../../../assets/images/svg/i_round_tick.svg';
import { ReactComponent as HomeIcon} from '../../../../assets/images/svg/i_home.svg';
import { RootState } from '../../../../store';
import { PayerInitialState } from '../../../../store/models/payerListModel';

const SuccessModal = ({ isModalVisible, setIsModalVisible }: any): ReactElement => {
  const history = useHistory();

  const gotoInPatient = (): void => {
    setIsModalVisible(false);
    Modal.destroyAll();
    history.replace('/reimbursement/home/list');
  };

  const footerButton = (): ReactElement[] => {
    const footerArray: ReactElement[] = [
      <Button data-testid="goto-inpatient-list" key="gotoInpatient" onClick={gotoInPatient}>
        <HomeIcon className="fill-primary v-align-middle" />&nbsp; Go to In-Patient Desk
      </Button>,
    ];
    return footerArray;
  };

  const { payer: { name: payerName } } =
    useSelector((state: RootState): PayerInitialState => state?.payerList || {});
  const successModalMsg = (
    <>
      <p className="text-success" data-testid="success-message">
          <p>Claim successfully submitted to <b>{payerName || 'Payer'}</b></p>
      </p>
      {footerButton()}
    </>
  );
  function success(): void {
    Modal.success({
      content: successModalMsg,
      okText: null,
      icon: <RoundTickIcon className="fill-success" />,
      className: 'success-modal text-center reimbursement-success-modal',
      width: 'max-content',
    });
  }
  return (
    isModalVisible && <>
      {success()}
    </>
  );

};

export default SuccessModal;
